/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRole } from './APIRole';
import {
    APIRoleFromJSON,
    APIRoleFromJSONTyped,
    APIRoleToJSON,
} from './APIRole';

/**
 * 
 * @export
 * @interface APIPaginatedRoleList
 */
export interface APIPaginatedRoleList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedRoleList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRoleList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRoleList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIRole>}
     * @memberof APIPaginatedRoleList
     */
    results: Array<APIRole>;
}

/**
 * Check if a given object implements the APIPaginatedRoleList interface.
 */
export function instanceOfAPIPaginatedRoleList(value: object): value is APIPaginatedRoleList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedRoleListFromJSON(json: any): APIPaginatedRoleList {
    return APIPaginatedRoleListFromJSONTyped(json, false);
}

export function APIPaginatedRoleListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedRoleList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIRoleFromJSON)),
    };
}

export function APIPaginatedRoleListToJSON(value?: APIPaginatedRoleList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIRoleToJSON)),
    };
}

